export default "__VITE_ASSET__DlCNzk5L__"